export function parseInvitationEmails(values: readonly string[]): string[] {
  const seen = new Set<string>()
  return values.flatMap((value) =>
    value.split(/[\s,;]+/).flatMap((part) => {
      const email = part.trim()
      const key = email.toLowerCase()
      if (!email || seen.has(key)) {
        return []
      }
      seen.add(key)
      return [email]
    }),
  )
}

export function getInvitationEmailError(
  emails: readonly string[],
): string | null {
  if (emails.length === 0) {
    return "Enter at least one email address."
  }
  const invalid = emails.find(
    (email) => email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
  )
  return invalid ? `Enter a valid email address for ${invalid}.` : null
}
